import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

const testimonials = [
  {
    quote:
      "PalNote gives me back almost two hours every day. I finish my notes before the patient even leaves the room.",
    name: "Dr. Sarah Chen",
    role: "Chiropractor, Apex Spine & Rehab",
    initials: "SC",
    gradient: "from-blue-500 to-sky-400",
  },
  {
    quote:
      "My documentation has never been this complete. The assistant catches the details I used to forget under a busy schedule.",
    name: "James Whitfield, PT",
    role: "Physiotherapist, Motion MSK Clinic",
    initials: "JW",
    gradient: "from-indigo-500 to-blue-400",
  },
  {
    quote:
      "I'm actually present with my patients now instead of staring at a screen. It's changed how I practice.",
    name: "Maria Alvarez, RMT",
    role: "Massage Therapist, Restore Clinic",
    initials: "MA",
    gradient: "from-sky-500 to-cyan-400",
  },
];

export function Testimonials() {
  return (
    <section className="bg-gradient-to-b from-white to-slate-50 py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">
            Testimonials
          </span>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Loved by busy clinicians
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure className="flex h-full flex-col rounded-2xl border border-slate-200/80 bg-white p-7 shadow-sm transition-shadow hover:shadow-lg hover:shadow-blue-900/5">
                <div className="flex gap-0.5 text-amber-400">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-current" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br ${t.gradient} text-sm font-semibold text-white`}
                  >
                    {t.initials}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-slate-900">{t.name}</p>
                    <p className="text-xs text-slate-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
